export default class DynamicDesktopToOverlaySwitcher {
  constructor(navbar) {
    this.navbar = navbar;
    this.ul = $(this.navbar).find(".page-navbar__menu > ul")[0];

    if (this.ul) {
      this._init();
    }
  }

  _init() {
    this.brand = $(this.navbar).find(".page-navbar__brand")[0];
    // event: init
    // this._setFixMenuItemWidths();
    this._handelWindowLoad();
  }

  _handelWindowLoad() {
    // If the user can't hover always show the mobil-menu
    if (!window.matchMedia("(hover: hover)").matches) {
      document.body.classList.add("navbar--uses-overlay");
      this.useOverlayToggle = true;
      $(window).trigger("luther:navbar--uses-overlay", [true]);
      // if the user can hover calculate the mobile breakpoint
    } else {
      this._getMenuBreakpoint().then((resp) => {
        this.breakpoint = resp.breakpoint;
        this.smallerBreakpoint = resp.smallerBreakpoint;
        window.addEventListener("resize", this._doSwitchIfNessesary.bind(this));
        this._doSwitchIfNessesary();
      });
    }
  }

  _getMenuBreakpoint() {
    return new Promise((resolve) => {
      const extraPadding = 100;

      let menuItems = 0;
      let smallerPaddingOffset = 0;
      for (let menuItem of this.ul.children) {
        menuItems += menuItem.clientWidth;
        smallerPaddingOffset += 30;
      }

      const LogoWidth = document.querySelector(
        ".page-navbar__brand",
      )?.clientWidth;

      const smallerBreakpoint =
        menuItems + LogoWidth + extraPadding + smallerPaddingOffset;
      const breakpoint = smallerBreakpoint - smallerPaddingOffset;
      resolve({ breakpoint, smallerBreakpoint });
    });
  }

  _handelWindowResize() {
    this._doSwitchIfNessesary();
  }

  _doSwitchIfNessesary() {
    const useOverlayToggle = this.useOverlayToggle || false;
    if (window.innerWidth < this.breakpoint) {
      if (!useOverlayToggle) {
        document.body.classList.add("navbar--uses-overlay");
        this.useOverlayToggle = true;
        $(window).trigger("luther:navbar--uses-overlay", [true]);
      }
    } else {
      if (useOverlayToggle) {
        document.body.classList.remove("navbar--uses-overlay");
        this.useOverlayToggle = false;
        $(window).trigger("luther:navbar--uses-overlay", [false]);
      }
    }

    // small breakpoint
    const tightenMenu = this.tightenMenu || false;
    if (
      window.innerWidth < this.smallerBreakpoint &&
      window.innerWidth > this.breakpoint
    ) {
      if (!tightenMenu) {
        this.navbar.classList.add("tighten-menu");
        this.tightenMenu = true;
      }
    } else {
      if (tightenMenu) {
        this.navbar.classList.remove("tighten-menu");
        this.tightenMenu = false;
      }
    }
  }
}
